const getCustomProp = (entry, key) => {
  if (entry?.customProps) {
    try {
      const props = JSON.parse(entry.customProps);
      if (props && typeof props === 'object' && !Array.isArray(props)) {
        return props[key];
      }
      return undefined;
    } catch {
      return undefined;
    }
  }
  return undefined;
};

const transformMediaData = (media) => {
  if (!media) return null;

  // Map media items to components structure
  const components = {
    id: media?.entryId,
    title: media?.title,
    isCarousel: media?.isCarousel || false,
    isAutoplay: media?.isAutoplay || false,
    altText: media?.sourceDesktop?.[0]?.altText || media?.sourceMobile?.[0]?.altText,
    link: media?.sourceDesktop?.[0]?.hyperlink || media?.sourceMobile?.[0]?.hyperlink,
    componentName: 'HeroFlattenImage',
    previewImage: {
      damDownloadedContent: {
        url: media?.sourceDesktop?.[0]?.uri
      },
      imageHotspot: media?.sourceDesktop?.[0]?.hotspot
    },
    mobilePreviewImage: {
      damDownloadedContent: {
        url: media?.sourceMobile?.[0]?.uri
      },
      imageHotspot: media?.sourceMobile?.[0]?.hotspot
    },
    posterImage: {
      damDownloadedContent: {
        url: media?.sourceDesktop?.[1]?.uri
      },
      imageHotspot: media?.sourceMobile?.[1]?.hotspot
    },
    sourceData: {
      desktop: media?.sourceDesktop?.[0],
      mobile: media?.sourceMobile?.[0]
    },
    theme: media?.theme,
    __typename: 'Section'
  };

  return {
    id: media.entryId,
    isCarousel: media.isCarousel || false,
    isAutoplay: media.isAutoplay || false,
    components: [
      components
    ],
    sourceData: {
      desktop: media?.sourceDesktop?.[0],
      mobile: media?.sourceMobile?.[0]
    },
    theme: media.theme,
    __typename: 'Section'
  };
};

export const normalizeBentoHeroData = ({ propsData, slotData, componentData, mediaCollectionIndex }) => {
  if (propsData) {
    return {
      source: 'props',
      data: { ...propsData, isLivePreviewData: true }
    };
  }

  if (componentData?.component) {
    return {
      source: 'component',
      data: componentData.component
    };
  }

  if (slotData?.slot) {
    const { slot } = slotData;

    // Map mediaCollections to bay structure (up to 4 bays)
    const mediaCollections = slot.mediaCollections || [];
    const fallbackMediaCollection = mediaCollections[0] || null;
    const mediaCollection = mediaCollections[mediaCollectionIndex] || fallbackMediaCollection;
    const allMedia = mediaCollection?.media || [];

    // Find sponsored media and separate from regular media
    let bentoSponsoredBanner = null;
    const regularMedia = [];

    allMedia.forEach((media) => {
      // Check if media is marked as sponsored (adjust property name as needed)
      if (media.isSponsored) {
        bentoSponsoredBanner = {
          id: media.entryId,
          customRenderId: media.customRenderId,
          schema: media.schema,
          theme: media.theme,
          showBanner: media.showBanner,
          imgDesktop: media.sourceDesktop?.[0]?.uri,
          imgMobile: media.sourceMobile?.[0]?.uri,
          clickthruUrl: media.sourceDesktop?.[0]?.hyperlink,
          specialDefaultBanner: getCustomProp(media, 'specialDefaultBanner'),
          __typename: 'SponsoredBanner'
        };
      } else {
        regularMedia.push(media);
      }
    });

    const firstBay = regularMedia[0] ? transformMediaData(regularMedia[0]) : null;
    const secondBay = regularMedia[1] ? transformMediaData(regularMedia[1]) : null;
    const thirdBay = regularMedia[2] ? transformMediaData(regularMedia[2]) : null;
    const fourthBay = regularMedia[3] ? transformMediaData(regularMedia[3]) : null;

    return {
      source: 'slot',
      data: {
        id: slot.id,
        theme: mediaCollection?.theme || null,
        firstBay,
        secondBay,
        thirdBay,
        fourthBay,
        bentoSponsoredBanner
      }
    };
  }
  return null;
};
